import React from 'react';
import { Calendar, ArrowLeft, Clock, User } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';

// Move blog posts data to a shared location
export const blogPosts = [
  {
    id: 1,
    title: "The Science of Progressive Overload",
    subtitle: "Understanding how to effectively increase your training intensity for maximum results",
    coverImage: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
    date: "March 15, 2024",
    category: "Training"
  },
  {
    id: 2,
    title: "Nutrition Timing for Optimal Performance",
    subtitle: "When and what to eat before, during, and after your workouts",
    coverImage: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
    date: "March 12, 2024",
    category: "Nutrition"
  },
  {
    id: 3,
    title: "Recovery Techniques for Athletes",
    subtitle: "Essential recovery methods to prevent injury and improve performance",
    coverImage: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
    date: "March 10, 2024",
    category: "Recovery"
  }
];

const BlogDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const post = blogPosts.find(p => p.id === parseInt(id));
  console.log(id);

  const handleBack = () => {
    navigate(-1);
  };

  // Handle case when post is not found
  if (!post) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-white to-purple-50 py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <button
            onClick={handleBack}
            className="flex items-center text-purple-600 hover:text-purple-700 mb-8 transition-colors"
          >
            <ArrowLeft size={20} className="mr-2" />
            Back to Blog
          </button>
          <div className="text-center py-12">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">Blog Post Not Found</h1>
            <p className="text-gray-600">The blog post you're looking for doesn't exist.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-purple-50 py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Back button */}
        <button
          onClick={handleBack}
          className="flex items-center text-purple-600 hover:text-purple-700 mb-8 transition-colors"
        >
          <ArrowLeft size={20} className="mr-2" />
          Back to Blog
        </button>

        {/* Blog header */}
        <div className="mb-8">
          <span className="bg-purple-600 text-white px-4 py-1 rounded-full text-sm font-medium inline-block mb-4">
            {post.category}
          </span>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {post.title}
          </h1>
          <div className="flex flex-wrap items-center text-gray-600 text-sm gap-4">
            <div className="flex items-center">
              <Calendar size={16} className="mr-2" />
              {post.date}
            </div>
            <div className="flex items-center">
              <Clock size={16} className="mr-2" />
              5 min read
            </div>
            <div className="flex items-center">
              <User size={16} className="mr-2" />
              Coach HT
            </div>
          </div>
        </div>

        {/* Featured image */}
        <div className="relative h-[400px] rounded-2xl overflow-hidden mb-8">
          <img
            src={post.coverImage}
            alt={post.title}
            className="w-full h-full object-cover"
          />
        </div>

        {/* Blog content */}
        <div className="prose prose-lg max-w-none">
          <p className="text-xl text-gray-600 mb-8">
            {post.subtitle}
          </p>
          
          <div className="space-y-6 text-gray-700">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              Key Points to Remember
            </h2>
            
            <ul className="list-disc pl-6 space-y-2">
              <li>Proper form and technique are essential for maximum results</li>
              <li>Consistency is key to achieving your fitness goals</li>
              <li>Nutrition plays a crucial role in your overall progress</li>
              <li>Recovery is just as important as the workout itself</li>
            </ul>
            
            <p>
              Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
            
            <blockquote className="border-l-4 border-purple-600 pl-4 italic text-gray-600">
              "Success is not final, failure is not fatal: it is the courage to continue that counts."
            </blockquote>
            
            <p>
              Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.
            </p>
          </div>
        </div>

        {/* Share and navigation section */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <div className="flex justify-between items-center">
            <button
              onClick={handleBack}
              className="flex items-center text-purple-600 hover:text-purple-700 transition-colors"
            >
              <ArrowLeft size={20} className="mr-2" />
              Back to Blog
            </button>
            <div className="flex space-x-4">
              <button className="text-gray-600 hover:text-purple-600 transition-colors">
                Share on Twitter
              </button>
              <button className="text-gray-600 hover:text-purple-600 transition-colors">
                Share on Facebook
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetails; 